import React from 'react';

const Privacy = () => (
  <div className="container py-24 min-h-screen">
    <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
    <p className="mb-4">
      I respect your privacy and am committed to protecting any information you may provide while visiting this website.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Information Collection</h2>
    <p className="mb-4">
      This website does not actively collect personal data. However, standard analytics tools (like Google Analytics) may be used to understand site usage trends.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. Cookies</h2>
    <p className="mb-4">
      Cookies may be used to enhance user experience. You can disable cookies through your browser settings if desired.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Third-Party Services</h2>
    <p className="mb-4">
      I may use third-party services (e.g., analytics, contact forms) that may collect limited information as governed by their own privacy policies.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Your Rights</h2>
    <p className="mb-4">
      You have the right to inquire about or request deletion of any personal data you may have submitted, if applicable.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. Updates</h2>
    <p className="mb-4">
      This policy may be updated occasionally. Please check back to stay informed of any changes.
    </p>

    <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
    <div className="mt-8 flex justify-center">
      <a href="/" className="inline-block px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors shadow">
        &larr; Return to Home
      </a>
    </div>
  </div>
);

export default Privacy;
